export enum CLAIMS {
  // Hub
  canManageApplicants = 'canManageApplicants',
  canManageBilling = 'canManageBilling',
  canManageBrands = 'canManageBrands',
  canManageCampaigns = 'canManageCampaigns',
  canManageCandidateNotes = 'canManageCandidateNotes',
  canManageCandidateSearch = 'canManageCandidateSearch',
  canManageCareerSites = 'canManageCareerSites',
  canManageHiringEvents = 'canManageHiringEvents',
  canManageImportExports = 'canManageImportExports',
  canManageLocations = 'canManageLocations',
  canManagePositions = 'canManagePositions',
  canManagePostings = 'canManagePostings',
  canManageUsers = 'canManageUsers',
  canViewApplicants = 'canViewApplicants',
  canViewCampaigns = 'canViewCampaigns',
  canViewCandidateNotes = 'canViewCandidateNotes',
  canViewFeeds = 'canViewFeeds',
  canViewHiringEvents = 'canViewHiringEvents',
  canViewLocations = 'canViewLocations',
  canViewPositions = 'canViewPositions',
  canViewPostings = 'canViewPostings',
  canViewUsers = 'canViewUsers',
  locationManager = 'locationManager',

  // Admin
  canImpersonate = 'canImpersonate',
}
